<template>
  <div id="layout">
    <IHeader />
    <!-- IHeader -->
    <Row>
      <Col :xs="sideBarFix[0]" :sm="sideBarFix[1]" :md="sideBarFix[2]" :lg="sideBarFix[3]" :xl="sideBarFix[4]">
      <ISidebar class="sidebar_left" ref="sidebar" />
      <!-- ISidebar -->
      </Col>
      <Col :xs="containerFix[0]" :sm="containerFix[1]" :md="containerFix[2]" :lg="containerFix[3]" :xl="containerFix[4]">
      <ITabs />
      <!-- ITabs -->
      <div id="container">
        <div id="main">
          <Button @click="changFix" size="small" type="primary" icon="ios-arrow-back" class="menuBtn" v-show="expand && !isMobile"></Button>
          <Button @click="changFix" size="small" type="primary" icon="ios-arrow-forward" class="menuBtn" v-show="!expand && !isMobile"></Button>
          <keep-alive>
            <router-view v-if="keepAlive" />
          </keep-alive>
          <router-view v-if="!keepAlive" />
          <!-- </transition> -->
        </div>
        <!-- #main -->
        <IFooter />
        <!-- IFooter -->
      </div>
      <!-- #container -->
      </Col>
    </Row>
    <IError />
    <!-- IError -->
  </div>
</template>
<script>
import IHeader from "@/layouts/partials/Header";
import ISidebar from "@/layouts/partials/Sidebar";
import ITabs from "@/layouts/partials/Tabs";
import IFooter from "@/layouts/partials/Footer";
import IError from "@/layouts/partials/Error";
import { mapGetters } from "vuex";
export default {
  name: "ILayout",
  components: {
    IHeader,
    ISidebar,
    ITabs,
    IFooter,
    IError,
  },
  data: () => ({
    pannelWidth: null,
    routes: [],
    keepAlive: true,
    menuhide: true,
    btn_logo: '',
    expand: true,
    sideBarFix:[0,0,5,4,3],
    containerFix:[24,24,19,20,21],
  }),
  computed: {
    ...mapGetters({
      isMobile: "getIsMobile",
      menu: "getMenu",
      tabs: "getTabs"
    })
  },
  watch: {
    // 侦听路由变化
    $route() {
      this.$store.commit("MENU_SELECT", this.$route.fullPath); // 选择菜单
      this.$refs["sidebar"].updateOpened(); // 手动更新展开的子菜单
      // 设置路由组件缓存
      for (const route of this.routes) {
        if (route.path === this.$route.path) {
          this.keepAlive = route.meta.keepAlive;
        }
      }
    },
    // 侦听标签变化
    tabs() {
      // 根据 tabs 的增减来判断路由组件是否进行缓存
      this.handleKeepAlive();
    }
  },
  mounted() {
    this.routes = this.$router["options"]["routes"][0]["children"]; // 获取动态路由
    // 根据 tabs 的增减来判断路由组件是否进行缓存
    this.handleKeepAlive();
  },
  methods: {
    // 根据 tabs 的增减来判断路由组件是否进行缓存
    handleKeepAlive() {
      for (const route of this.routes) {
        if (route.meta.keepAliveUse) {
          route.meta.keepAlive = false;
        }
        for (const tab of this.tabs) {
          if (route.path === tab.path) {
            route.meta.keepAliveUse = true;
            route.meta.keepAlive = true;
          }
        }
      }
    },
    changFix(){
      if (this.expand == false){//打开
        this.sideBarFix= [0,0,5,4,3]
        this.containerFix = [24,24,19,20,21]
        this.expand = true;
      } else if (this.expand == true){
        this.sideBarFix= [0,0,0,0,0]
        this.containerFix = [24,24,24,24,24]
        this.expand = false;
      }
      this.$forceUpdate();
    }
  }
};
</script>
<style lang="postcss">
#container {
  background-color: #f0f0f0;
  height: calc(100vh - 100px);
  overflow: auto;

  & #main {
    min-height: calc(100% - 43px);
    overflow: hidden;
    padding: 16px;
    padding-top: 5px;
  }

  /* fade-transform */
  & .fade-transform-enter-active,
  & .fade-transform-leave-active {
    transition: all 0.3s;
  }

  & .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  & .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
}
.sidebar_left{

}
.menuBtn {
  margin-left: -16px!important;
  position: fixed;
  z-index: 10;
  top: 50%;
  width: 16px!important;
  height: 65px!important;
  border-radius: 2px!important;
}

/deep/ .ivu-btn>.ivu-icon {
  line-height: 1.5;
  font-size: 18px;
}

/deep/ .ivu-btn-group-vertical>.ivu-btn {
  min-width: 16px;
}
</style>
